<div class="content-wrapper scroll" style="filter: blur(4px);">
    <div class="row m-0 align-items-center justify-content-center">
        <div class="color-secondary sub-heading fw-bold">
            Dashboard
        </div>
        <div class="view-switcher justify-content-end">
            <button *ngFor="let view of views" [ngClass]="{ active: view === currentView }" (click)="updateView(view)">
                {{ view }}
            </button>

            <!-- Year Selector for Monthly and Quarterly -->
            <div class="year-selector">
                <label for="year">Select Year:</label>
                <select id="year" [(ngModel)]="selectedYear" (change)="updateYear(selectedYear)">
                    <option *ngFor="let year of availableYears" [value]="year">
                        {{ year }}
                    </option>
                </select>
            </div>
        </div>

    </div>




    <!-- <div class="description-text px-2 mx-2">Job Description if have</div> -->
    <div class="row m-0 align-items-center justify-content-center scroll">
        <div class="row justify-content-around px-2">
            <div class="card-custom white d-flex align-items-center px-3">
                <div class="text-section me-3">
                    <small class="text-black-50">Total Jobs</small>
                    <div class="text-black mb-0">4,235</div>
                </div>
                <div class="icon-section">
                    <i class="fa-solid fa-cart-shopping text-white"></i>
                </div>
            </div>


            <div class="card-custom blue d-flex align-items-center px-3">
                <div class="text-section me-3">
                    <small class="text-white-50">Completed Jobs</small>
                    <div class="text-white mb-0">4,235</div>
                </div>
                <div class="icon-section">
                    <i class="fa-solid fa-square-check"></i>
                </div>
            </div>

            <div class="card-custom yellow d-flex align-items-center px-3">
                <div class="text-section me-3">
                    <small class="text-white-50">Pending Jobs</small>
                    <div class="text-white mb-0">4,235</div>
                </div>
                <div class="icon-section">
                    <i class="fa-solid fa-clock"></i>
                </div>
            </div>

            <div class="card-custom red d-flex align-items-center px-3">
                <div class="text-section me-3">
                    <small class="text-white-50">Canceled Jobs</small>
                    <div class="text-white mb-0">4,235</div>
                </div>
                <div class="icon-section">
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>

        </div>
        <!-- old code  for show -->
        <div class="row flex-display px-2">
            <div class="col-5 px-1">
                <!-- <div class="row px-2"> -->
                <div class="col-12">
                    <app-sales-chart [view]="currentView" [selectedYear]="selectedYear"></app-sales-chart>
                </div>
                <!-- </div> -->
                <!-- <div class="row px-0"> -->
                <!-- <div class="card-custom white d-flex align-items-center px-1">
                        <div class="text-section me-3">
                            <small class="text-black-50">Total Jobs</small>
                            <div class="text-black mb-0">4,235</div>
                        </div>
                        <div class="icon-section">
                            <i class="fa-solid fa-cart-shopping text-white"></i>
                        </div>
                    </div>
        
        
                    <div class="card-custom blue d-flex align-items-center px-1">
                        <div class="text-section me-3">
                            <small class="text-white-50">Completed Jobs</small>
                            <div class="text-white mb-0">4,235</div>
                        </div>
                        <div class="icon-section">
                            <i class="fa-solid fa-square-check"></i>
                        </div>
                    </div> -->

                <!-- </div> -->
            </div>
            <div class="col-7 px-1">
                <app-bar-chart [view]="currentView" [selectedYear]="selectedYear"></app-bar-chart>
            </div>
        </div>

        <div class="row flex-display justify-content-around my-5">
            <div class="col-7 d-flex ">
                <app-parts-line-chart [view]="currentView" [selectedYear]="selectedYear"></app-parts-line-chart>
            </div>
            <div class="col-5 d-flex">
                <!-- <app-sales-chart></app-sales-chart> -->
                <app-pie-chart [view]="currentView" [selectedYear]="selectedYear"></app-pie-chart>
            </div>
        </div>
        <!-- end old -->
    </div>

    <div class="dashboard">
        <div class="chart-row">
            <div class="chart-container sales chart-col-5">
                <div class="card-header">
                    <div class="card-title">
                        <strong>Sales</strong>
                    </div>
                    <div class="card-value">
                        <!-- ₹{{ totalAmount | number }} -->
                        <span class="amount">₹612000</span>
                    </div>
                </div>
                <!-- {{ dateRange }} {{selectedYear}} -->
                <div class="card-subtitle">jan - mar</div>
                <canvas id="salesChart1"></canvas>
            </div>
            <div class="chart-container chart-col-7">
                <canvas id="jobChart1"></canvas>
            </div>
        </div>
        <div class="chart-row">
            <div class="chart-container chart-col-7">
                <canvas id="doubleChart1"></canvas>
            </div>
            <div class="chart-container chart-col-5">
                <canvas id="pieChart1"></canvas>
            </div>
        </div>
    </div>
    <!-- here that pasted -->
    <div>
        <!-- <canvas id="pieChart1"></canvas>
        <canvas id="doubleChart1"></canvas>
        <canvas id="jobChart1"></canvas>
        <canvas id="salesChart1"></canvas> -->
        <!-- <canvas id="jobChart1"></canvas> -->
    </div>
</div>